<template>
  <div class="upload-file-cell">
    <el-link type="primary" @click="chooseFiles">{{ value.length }}{{ $t('addasn.exhibition.accessoryCount') }}</el-link>
  </div>
</template>

<script>
import Dialog from '@utils/common/dialog'
import Form from '@utils/form'
import UploadSelect from '@/components/select/upload-select/upload-select.vue'

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    row: {
      type: Object,
      default: () => ({})
    },
    // eslint-disable-next-line
    parse: Function
  },
  computed: {
    dialog() {
      const fileNoAttrs = {
        parse: this.parse,
        disabled: true
      }

      const form = new Form('common')
        .add('value').label('file').component(UploadSelect).attrs(fileNoAttrs).col({ span: 24 })

      const dialog = new Dialog('common')
        .title('previewFile')
        .isfooter(false)
        .form(form)

      return dialog
    }
  },
  methods: {
    async chooseFiles() {
      const vm = await this.dialog.open({ attrs: { row: { value: this.value }}})
      this.row.asnBodyFileList = vm.data.value
    }
  }
}
</script>
